document.addEventListener("DOMContentLoaded", function () {

let swiper = new Swiper('.bestselling-product-listing', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3.2,   
        allowTouchMove: true,
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
        loopedSlides: 8, // according to the codepen
        followFinger: true,
      //     mousewheel: {
      //   releaseOnEdges: true,
      // },
        keyboard: {
        enabled: true, // enable keyboard navigation
        onlyInViewport: false, // allow keyboard outside the viewport
      },
            scrollbar: {
              el: ".swiper-scrollbar",
              hide: false,
            draggable: false 
            },
            breakpoints: {
                1920: {
                    slidesPerView: 4.11,
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 3.2,
                    spaceBetween: 20
                },
                749: {
                    slidesPerView: 2.6,
                    spaceBetween: 20
                },
                492: {
                    slidesPerView:2.06,
                    spaceBetween: 8
                }
            }
    });


const blogSwiperEl = document.querySelector('.blog-swiper');
const blogSlides = blogSwiperEl?.querySelectorAll('.swiper-slide').length || 0;

if (blogSlides > 3) {
  let blogSwiper = new Swiper('.blog-swiper', {
    loop: false,
    followFinger: true,
    allowTouchMove: true,
    spaceBetween: 35,

    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },

    slidesPerView: 3, 

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      enabled: false,
    },

    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      enabled: true,
    },

    breakpoints: { 
      1024: { slidesPerView: 3, spaceBetween: 16, pagination: { enabled: false }, scrollbar: { enabled: true } }, 
      990: { slidesPerView: 2.2, spaceBetween: 16, pagination: { enabled: false }, scrollbar: { enabled: true } }, 
      749: { slidesPerView: 2, slidesPerColumn: 2, slidesPerGroup: 2, spaceBetween: 16, pagination: { enabled: true }, scrollbar: { enabled: false }, },
     }
  });
}

//  blog post table of content with scroll and click event.


// ======= CONFIG =======
const HEADER_OFFSET = 220;     // Fixed header height
const EXTRA_OFFSET = 50;       // Extra space normally
const DOWN_CLICK_PUSH = 0;    // Extra push only for downward clicks
const ACTIVATION_BUFFER = 0;  // Prevent early highlight

// ======= DOM SELECTORS =======
const tocSource = document.querySelector(".article-left-content .article_content");
const articleContent = document.querySelector(".article-template__content .article_content");
const tocList = document.querySelector(".article-titles");

if (tocSource && articleContent && tocList) {
  const sourceHeadings = tocSource.querySelectorAll("h2, h3");
  const targetHeadings = articleContent.querySelectorAll("h2, h3");

  const tocItems = [];
  let currentActiveIndex = 0;   // Track active heading
  let isClickScrolling = false; // Lock while click-scroll
  let lastScrollY = window.pageYOffset;

  // ======= CREATE TOC =======
  sourceHeadings.forEach((heading, index) => {
    const targetHeading = targetHeadings[index];
    if (!targetHeading) return;

    targetHeading.id = `toc-heading-${index}`;

    const cleanText = heading.innerText.replace(/^\s*\d+[\.\)\-:]\s*/g, "");
    const li = document.createElement("li");
    li.innerText = cleanText;

    if (index === 0) li.classList.add("active-toc");

    tocList.appendChild(li);
    tocItems.push(li);

    // ======= CLICK HANDLER =======
    li.addEventListener("click", () => {
      isClickScrolling = true;
      lastScrollY = window.pageYOffset;

      // Highlight clicked TOC item
      tocItems.forEach(el => el.classList.remove("active-toc"));
      li.classList.add("active-toc");

      // Extra push if clicking downward
      const isClickingDown = index > currentActiveIndex;
      const dynamicOffset = isClickingDown
        ? EXTRA_OFFSET + DOWN_CLICK_PUSH
        : EXTRA_OFFSET;

      const top =
        targetHeading.getBoundingClientRect().top +
        window.pageYOffset -
        HEADER_OFFSET +
        dynamicOffset;

      window.scrollTo({ top, behavior: "smooth" });

      // Unlock after scroll completes
      setTimeout(() => {
        isClickScrolling = false;
        currentActiveIndex = index;
      }, 1000);
    });
  });

   window.addEventListener("scroll", () => {
    const currentScrollY = window.pageYOffset;

    if (isClickScrolling) {
      lastScrollY = currentScrollY;
      return; // Ignore scroll caused by click
    }

    let currentIndex = 0;
    const scrollPosition = currentScrollY + HEADER_OFFSET + ACTIVATION_BUFFER;

    targetHeadings.forEach((heading, index) => {
      const headingTop = heading.getBoundingClientRect().top + currentScrollY;
      if (headingTop <= scrollPosition) {
        currentIndex = index;
      }
    });

    tocItems.forEach(li => li.classList.remove("active-toc"));
    tocItems[currentIndex]?.classList.add("active-toc");

    currentActiveIndex = currentIndex; // Sync active index
    lastScrollY = currentScrollY;
  });
  // ======= SCROLL HIGHLIGHT (MANUAL SCROLL ONLY) =======
 
}










  /* ================= TOC ================= */
  // const tocSource = document.querySelector(".article-left-content .article_content");
  // const articleContent = document.querySelector(".article-template__content .article_content");
  // const tocList = document.querySelector(".article-titles");

  // if (tocSource && articleContent && tocList) {

  //   const sourceHeadings = tocSource.querySelectorAll("h2, h3");
  //   const targetHeadings = articleContent.querySelectorAll("h2, h3");
  //   const HEADER_OFFSET = 170;

  //   sourceHeadings.forEach((heading, index) => {
  //     const targetHeading = targetHeadings[index];
  //     if (!targetHeading) return;

  //     const id = `toc-heading-${index}`;
  //     targetHeading.id = id;

  //     const cleanText = heading.innerText.replace(/^\s*\d+[\.\)\-:]\s*/g, '');
  //     const li = document.createElement("li");
  //     li.innerText = cleanText;

  //     if (index === 0) li.classList.add("active-toc");

  //     li.addEventListener("click", () => {
  //       document.querySelectorAll(".article-titles li")
  //         .forEach(el => el.classList.remove("active-toc"));

  //       li.classList.add("active-toc");

  //       const top = targetHeading.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
  //       window.scrollTo({ top, behavior: "smooth" });
  //     });

  //     tocList.appendChild(li);
  //   });
  // }
// const scrollContainer = document.querySelector(
//   ".article-template__content .article_content"
// );
// const headings = scrollContainer.querySelectorAll("h2, h3");
// const tocItems = document.querySelectorAll(".article-titles li");

// const HEADER_OFFSET = 100;

// scrollContainer.addEventListener("scroll", () => {
//   let currentIndex = 0;
//   const scrollPosition = scrollContainer.scrollTop + HEADER_OFFSET;

//   headings.forEach((heading, index) => {
//     if (heading.offsetTop <= scrollPosition) {
//       currentIndex = index;
//     }
//   });

//   tocItems.forEach(li => li.classList.remove("active-toc"));

//   if (tocItems[currentIndex]) {
//     tocItems[currentIndex].classList.add("active-toc");
//   }
// });

// const headings = document.querySelectorAll(
//   ".article-template__content .article_content h2, .article-template__content .article_content h3"
// );
// const tocItems = document.querySelectorAll(".article-titles li");

// const HEADER_OFFSET = 100;
// const UP_SCROLL_EXTRA_OFFSET = 300; // 👈 tune this

// let lastScrollY = window.pageYOffset;

// window.addEventListener("scroll", () => {
//   const currentScrollY = window.pageYOffset;
//   const isScrollingUp = currentScrollY < lastScrollY;

//   let currentIndex = 0;

//   const scrollPosition =
//     currentScrollY +
//     HEADER_OFFSET +
//     (isScrollingUp ? UP_SCROLL_EXTRA_OFFSET : 0);

//   headings.forEach((heading, index) => {
//     const headingTop = heading.getBoundingClientRect().top + currentScrollY;

//     if (headingTop <= scrollPosition) {
//       currentIndex = index;
//     }
//   });

//   tocItems.forEach(li => li.classList.remove("active-toc"));

//   if (tocItems[currentIndex]) {
//     tocItems[currentIndex].classList.add("active-toc");
//   }

//   lastScrollY = currentScrollY;
// });




  /* ================= RELATED BLOGS SWIPER ================= */
  // document.querySelectorAll('.related-blogs-swiper').forEach(slider => {
  //   if (slider.classList.contains('swiper-initialized')) return;

  //   new Swiper(slider, {
  //     loop: true,
  //     spaceBetween: 3,
  //     slidesPerView: 3,
  //     navigation: {
  //       nextEl: slider.querySelector('.swiper-button-next'),
  //       prevEl: slider.querySelector('.swiper-button-prev'),
  //     },
  //     breakpoints: {
  //       0: { slidesPerView: 1 },
  //       768: { slidesPerView: 2 },
  //       1024: { slidesPerView: 3 },
  //     }
  //   });
  // });

  /* ================= BEST SELLING SWIPER ================= */
  const bestSellingSwiper = document.querySelector('.best-selling-swiper');

  if (bestSellingSwiper) {
    const slidesCount = bestSellingSwiper.querySelectorAll('.swiper-slide').length;

    new Swiper(bestSellingSwiper, {
      loop: slidesCount > 3,
      loopedSlides: slidesCount,
      slidesPerView: 3,
      spaceBetween: 10,

      navigation: {
        nextEl: '.best-selling-swiper .swiper-button-next',
        prevEl: '.best-selling-swiper .swiper-button-prev',
      },

      scrollbar: {
        el: '.best-selling-swiper .swiper-scrollbar',
        draggable: true,
      },

      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },

      on: {
        init() { window.jdgm && jdgm.init(); },
        slideChange() { window.jdgm && jdgm.init(); }
      }
    });
  }

  /* ================= READ TIME ================= */
  setTimeout(() => {
       const readTimeContainer = document.querySelector(".article-read");

  if (articleContent && readTimeContainer) {
    const text = articleContent.innerText || articleContent.textContent;
    const words = text.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / 200);

    readTimeContainer.innerHTML = ` ● ${minutes} min read`;
  }
  }, 1500);
 

});
